import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AddRole, getManagementList } from "../../api/Role";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";


export default function RoleAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [managements, setManagements] = useState([]);
  const [selectedRoutes, setSelectedRoutes] = useState([]);

  const ManagementList = async () => {
    setLoading(true);
    try {
      const response = await getManagementList();
      if (response?.data?.status === true) {
        setManagements(response?.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const SubmitForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    try {
      const response = await AddRole(formData);

      if (response?.data?.status === true) {
        navigate("/role");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ManagementList();
  }, []);
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
           <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4>Role Add</h4>
                      <Link to={`/role`} className="btn btn-sm btn-primary">
                        Back
                      </Link>
                    </div>
                    <form action="" onSubmit={SubmitForm}>
                      <div className="form-floating form-floating-outline mb-5">
                        <input
                          type="text"
                          className="form-control  input-uppercase"
                          name="name"
                        />
                        <label htmlFor="">Rale Name</label>
                      </div>
                      <div className="mb-3">
                        <div className="form-check form-switch fs-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="select-all"
                            checked={
                              managements?.length > 0 &&
                              managements.every((m) =>
                                m.routes.every((r) =>
                                  selectedRoutes.includes(r.id)
                                )
                              )
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                const allRoutes = managements.flatMap((m) =>
                                  m.routes.map((r) => r.id)
                                );
                                setSelectedRoutes([...new Set(allRoutes)]);
                              } else {
                                setSelectedRoutes([]);
                              }
                            }}
                          />
                          <label
                            className="form-check-label fs-6"
                            htmlFor="select-all"
                          >
                            Select All Routes (All Managements)
                          </label>
                        </div>
                      </div>

                      {managements?.map((management, i) => {
                        const allSelected =
                          management.routes?.every((route) =>
                            selectedRoutes.includes(route.id)
                          ) || false;

                        return (
                          <div className="card my-3" key={i}>
                            <div className="card-header d-flex align-items-center justify-content-between border-bottom  pb-2">
                              <p className="text-primary h4 mb-0">
                                {management?.name}
                              </p>
                              <div className="form-check form-switch fs-6">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`all-${management?.name}`}
                                  checked={allSelected}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      const newRoutes = [
                                        ...new Set([
                                          ...selectedRoutes,
                                          ...management.routes.map(
                                            (r) => r.id
                                          ),
                                        ]),
                                      ];
                                      setSelectedRoutes(newRoutes);
                                    } else {
                                      const newRoutes = selectedRoutes.filter(
                                        (id) =>
                                          !management.routes.some(
                                            (r) => r.id === id
                                          )
                                      );
                                      setSelectedRoutes(newRoutes);
                                    }
                                  }}
                                />
                                <label
                                  className="form-check-label fs-6 ri-14px"
                                  htmlFor={`all-${management?.name}`}
                                >
                                  All Select
                                </label>
                              </div>
                            </div>

                            <div className="card-body p-2 px-4">
                              <div className="row">
                                {management?.routes?.map((route, k) => (
                                  <div
                                    className="col-lg-3 col-md-4 col-sm-6 mb-2"
                                    key={k}
                                  >
                                    <div className="form-check form-switch fs-5">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`route-${route?.id}`}
                                        name="routes[]"
                                        value={route?.id}
                                        checked={selectedRoutes.includes(
                                          route.id
                                        )}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setSelectedRoutes([
                                              ...selectedRoutes,
                                              route.id,
                                            ]);
                                          } else {
                                            setSelectedRoutes(
                                              selectedRoutes.filter(
                                                (id) => id !== route.id
                                              )
                                            );
                                          }
                                        }}
                                      />
                                      <label
                                        className="form-check-label fs-6"
                                        htmlFor={`route-${route?.id}`}
                                      >
                                        {route?.name}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      <div className="text-end p-1 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
